/* eslint-disable linebreak-style */
import {
  Box,
  Button, CircularProgress, IconButton, InputAdornment, TextField, Typography,
  withStyles
} from '@material-ui/core';
import { LockOpenOutlined, Visibility, VisibilityOff } from '@material-ui/icons';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import {
  EHRresetpassword,
  EHRresetpasswordsubmit,
  getUserByUsername
} from 'services/user/action';
import validate from 'validate.js';
import styles from '../../../SignIn/style';
import schema from './schema';

import { login } from 'services/profile/action';

import { connect } from 'react-redux';
import { Roles } from 'util/enum';

const Passwordreset = props => {
  const { classes } = props;
  const [tokenInvalid, setTokenInvalid] = useState(false);
  const [values, setValues] = useState({
    token: '',
    username: '',
    password: '',
    confirmpassword: '',
    succMsg: false,
    touched: {},
    errors: {},
    isValid: false
  });

  useEffect(() => {
    // let ntoken =
    //   props.history && props.history.location && props.history.location.search ;
    // ntoken = ntoken.slice(7);
    // setValues({...values,token:ntoken});
    fetchUser();
  }, []);

  const parseQueryString = url => {
    var objURL = {};
    url.replace(new RegExp('([^?=&]+)(=([^&]*))?', 'g'), function (
      _$0,
      $1,
      _$2,
      $3
    ) {
      objURL[$1] = $3;
    });
    return objURL;
  };

  const hasError = field =>
    values &&
      values.touched &&
      values.errors &&
      values.touched[field] &&
      values.errors[field]
      ? true
      : false;

  const fetchUser = async () => {
    let url = window.location.href;
    var params = parseQueryString(url);
    const res = await props.EHRresetpassword(params['token']);
    if (res.status === 200) {
      let newurl = res.data;
      var loginparams = parseQueryString(newurl);
      if (loginparams['username']) {
        // const userRes = await props.getUserByUsername(
        //   loginparams['ehrid'],
        //   loginparams['username']
        // );
        // if(userRes.status){
        // const loginStatus = await props.login(
        //   userRes.data.username,
        //   userRes.data.password,
        //   false,
        //   true
        // );
        // if (userRes.status) {
        setValues({
          ...values,
          username: loginparams['username'],
          ehrid: loginparams['ehrid'],
          token: params['token']
        });
        //   }
        // }
      }
    } else {
      setTokenInvalid(true);
    }
  };

  const handleFieldChange = (field, value) => {
    const newState = { ...values };
    newState[field] = value;
    newState.touched[field] = true;
    const errors = validate(newState, schema);
    newState.errors = errors || {};
    newState.isValid = errors ? false : true;
    setValues(newState);
    if (values) {
      // setIsBlocking(true);
    }
  };
  const validateForm = () => {
    const newState = { ...values };
    const errors = validate(values, schema);
    newState.errors = errors || {};
    newState.isValid = errors ? false : true;
    setValues(newState);

    return newState.isValid;
  };
  const handleSubmit = async () => {
    if (validateForm()) {
      const userRes = await props.getUserByUsername(
        values.ehrid,
        values.username
      );
      let newState = {
        // username: values.username,
        password: btoa(values.password),
        confirmpassword: values.password
      };
      props
        .EHRresetpasswordsubmit(values.ehrid, values.token, newState)
        .then(status => {
          if (status) {
            if ((userRes.data.role === Roles.patient) || (userRes.data.role === Roles.staff)) {
              props.history.push('/pt-login');
            } else props.history.push('/sign-in');
          } else {
            setValues({ ...values, isLoading: false, succMsg: false });
          }
        });
    }

    // setIsBlocking(false);
    // props.onCancel();
  };

  const handleClickShowPassword = () => {
    setValues({ ...values, showPassword: !values.showPassword });
  };
  const handleClickShowConfirmPassword = () => {
    setValues({ ...values, showConfirmPassword: !values.showConfirmPassword });
  };

  return (
    <span>
      <div
        className={classes.contentBodyMsg}
        style={{ position: 'relative' }}>
        <div className={classes.contentHeader}>
          <LockOpenOutlined />
          <Typography variant="h1">Reset Your Password</Typography>
        </div>
        <div className={classes.contentInner}>
          {tokenInvalid ? (
            <Box
              sx={{
                mb: 2,
                p: 2,
                borderRadius: 2,
                bgcolor: '#F3F4F6',
                border: '1px solid #E5E7EB',
                gap: 1.5,
              }}
            >
              <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <Typography variant="h5" color="error" gutterBottom>
                  This reset link is invalid or has expired. Please contact support{' '}
                  <a href="mailto:admin@ehrzip.com">admin@ehrzip.com</a>.
                </Typography>
              </Box>
            </Box>
          ) : (values?.token ?
            <div style={{ marginBottom: 5 }}>
              <div style={{ marginTop: 20 }}>
                <TextField
                  color="Primary"
                  error={values.errors && values.errors.password}
                  helperText={
                    hasError('password') ? values.errors.password[0] : null
                  }
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          edge="end"
                          aria-label="toggle password visibility"
                          onClick={handleClickShowPassword}>
                          {!values.showPassword ? (
                            <VisibilityOff />
                          ) : (
                            <Visibility />
                          )}
                        </IconButton>
                      </InputAdornment>
                    )
                  }}
                  InputLabelProps={{
                    classes: {
                      focused: classes.labelFocused
                    }
                  }}
                  label="New Password"
                  name="npw"
                  onChange={event =>
                    handleFieldChange('password', event.target.value)
                  }
                  required
                  style={{ width: '550px' }}
                  type={values.showPassword ? 'text' : 'password'}
                  value={values.password}
                  variant="outlined"
                />
              </div>
              <div style={{ marginTop: 20 }}>
                <TextField
                  color="Primary"
                  error={values.errors && values.errors.confirmpassword}
                  helperText={
                    hasError('confirmpassword')
                      ? values.errors.confirmpassword[0]
                      : null
                  }
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          edge="end"
                          aria-label="toggle password visibility"
                          onClick={handleClickShowConfirmPassword}>
                          {!values.showConfirmPassword ? (
                            <VisibilityOff />
                          ) : (
                            <Visibility />
                          )}
                        </IconButton>
                      </InputAdornment>
                    )
                  }}
                  InputLabelProps={{
                    classes: {
                      focused: classes.labelFocused
                    }
                  }}
                  label="Confirm New Password"
                  name="cnpw"
                  onChange={event =>
                    handleFieldChange('confirmpassword', event.target.value)
                  }
                  required
                  style={{ width: '550px' }}
                  type={values.showConfirmPassword ? 'text' : 'password'}
                  value={values.confirmpassword}
                  variant="outlined"
                />
              </div>
              <div style={{ marginTop: '20px' }}>
                <Button
                  color="primary"
                  onClick={() => handleSubmit()}
                  variant="contained">
                  Reset Password
                </Button>
              </div>
            </div>
            :
            <CircularProgress size={30} color="primary" />)}
        </div>
      </div>
    </span >
  );
};

Passwordreset.propTypes = {
  history: PropTypes.object
};

const mapDispatchToProps = {
  EHRresetpassword,
  EHRresetpasswordsubmit,
  login,
  getUserByUsername
};

const mapStateToProps = () => ({
  //user:state.user
  // titles: state.util.titles,
  //ehrID: state.profile && state.profile.ehrID,
  // // userID: state.profile && state.profile.userID,
  //username: state.profile && state.profile.name
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withStyles(styles)(Passwordreset))
);
